<template>
    <div class="content">
        <div class="content-head">
            <div class="content-head-title">搜索</div>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="项目类型">
                    <el-select v-model="params.Credit_Control_Type" placeholder="请选择项目类型" class="el-select-medium" value-key="ID" @change="getChangeControlType()">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option v-for="item in ControlTypeopt" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="当前状态">
                    <el-button type="primary" plain @click="getChangeControlstatus()">选择状态</el-button>
                </el-form-item>
                <el-form-item label="客户名称">
                    <el-input v-model="params.Credit_Control_CustomerName" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="项目id">
                    <el-input v-model="params.CreditID" placeholder="多个英文,分割" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="经办人" v-if="isFiltration">
                    <el-input v-model="params.officeman" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="原件存档">
                    <el-input v-model="params.Enclosure" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="项目金额" v-if="isFiltration">
                    <el-input v-model="params.startCredit_Control_ProjectMoney" placeholder="" clearable class="el-select-mini" @input="handleInput($event, 'params', 'startCredit_Control_ProjectMoney')"></el-input>
                    -
                    <el-input v-model="params.endCredit_Control_ProjectMoney" placeholder="" clearable class="el-select-mini" @input="handleInput($event, 'params', 'endCredit_Control_ProjectMoney')"></el-input>
                </el-form-item>

                <el-form-item label="已完成金额" v-if="isFiltration">
                    <el-input v-model="params.startReturnMoney" @input="handleInput($event, 'params', 'startReturnMoney')" placeholder="" clearable class="el-select-mini"></el-input>
                    -
                    <el-input v-model="params.endReturnMoney" @input="handleInput($event, 'params', 'endReturnMoney')" placeholder="" clearable class="el-select-mini"></el-input>
                </el-form-item>

                <el-form-item label="包含订单" v-if="isFiltration">
                    <el-input v-model="params.Orders_SN" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item label="经办人所属与订单所属机构不一致" v-if="isFiltration">
                    <el-checkbox v-model="params.IsBranchOfficeID"></el-checkbox>
                </el-form-item>

                <el-form-item label="按期付款额" v-if="isFiltration">
                    <el-input v-model="params.startOnTimeReturnMoney" @input="handleInput($event, 'params', 'startOnTimeReturnMoney')" placeholder="" clearable class="el-select-mini"></el-input>
                    -
                    <el-input v-model="params.endOnTimeReturnMoney" @input="handleInput($event, 'params', 'endOnTimeReturnMoney')" placeholder="" clearable class="el-select-mini"></el-input>
                </el-form-item>

                <el-form-item label="逾期付款额" v-if="isFiltration">
                    <el-input v-model="params.startOverdueReturnMoney" @input="handleInput($event, 'params', 'startOverdueReturnMoney')" placeholder="" clearable class="el-select-mini"></el-input>
                    -
                    <el-input v-model="params.endOverdueReturnMoney" @input="handleInput($event, 'params', 'endOverdueReturnMoney')" placeholder="" clearable class="el-select-mini"></el-input>
                </el-form-item>
                <el-form-item label="未完成金额" v-if="isFiltration">
                    <el-input v-model="params.startUnfinishedMoney" @input="handleInput($event, 'params', 'startUnfinishedMoney')" placeholder="" clearable class="el-select-mini"></el-input>
                    -
                    <el-input v-model="params.endUnfinishedMoney" @input="handleInput($event, 'params', 'endUnfinishedMoney')" placeholder="" clearable class="el-select-mini"></el-input>
                </el-form-item>

                <el-form-item label="三十日内将到期承诺金额" v-if="isFiltration">
                    <el-input v-model="params.startCommitmentAmount" @input="handleInput($event, 'params', 'startCommitmentAmount')" placeholder="" clearable class="el-select-mini"></el-input>
                    -
                    <el-input v-model="params.endCommitmentAmount" @input="handleInput($event, 'params', 'endCommitmentAmount')" placeholder="" clearable class="el-select-mini"></el-input>
                </el-form-item>
                <el-form-item label="剩余天数" v-if="isFiltration">
                    <el-input v-model="params.startLitigationDay" @input="handleInput($event, 'params', 'startLitigationDay')" placeholder="" clearable class="el-select-mini"></el-input>
                    -
                    <el-input v-model="params.endLitigationDay" @input="handleInput($event, 'params', 'endLitigationDay')" placeholder="" clearable class="el-select-mini"></el-input>
                </el-form-item>

                <el-form-item label="成立日期" v-if="isFiltration">
                    <el-date-picker v-model="dateTimer" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getCreditControls(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh()" icon="el-icon-refresh" :loading="loadingBtn">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="multiple-status-checked" v-if="this.params.StateList && this.params.StateList.length > 0">
                <span class="multiple-status-checked-lable">所选状态：</span>
                <span class="multiple-status-checked-value" v-for="(item, index) in multiple_status_list" :key="index">{{ item.Name }}</span>
            </div>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                信控项目管理列表
                <span>
                    <el-button type="primary" @click="getopenControlAdd()" icon="el-icon-plus">新增</el-button>

                    <el-dropdown trigger="click" style="margin-left: 10px; margin-right: 10px">
                        <el-button>
                            导出
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="getCreditControlExport()">导出查询信息</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button type="text" @click="getCreditControlStatistics()">汇总</el-button>
                </span>
            </div>
            <el-table  :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="tableData" :height="maxheight" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <el-table-column prop="Credit_Control_ID" label="ID" align="center" width="80" fixed="left"></el-table-column>
                <el-table-column prop="Credit_Control_TypeName" label="项目类型" align="center" show-overflow-tooltip width="120" fixed="left"></el-table-column>
                <el-table-column prop="Credit_Control_StateName" label="状态" align="center" show-overflow-tooltip width="120"></el-table-column>
                <el-table-column prop="Credit_Control_OfficeName" label="分支机构" align="center" show-overflow-tooltip width="120"></el-table-column>
                <el-table-column prop="Credit_Control_LargeRegionName" label="大区" align="center" show-overflow-tooltip width="100"></el-table-column>
                <el-table-column prop="Credit_Control_AgentName" label="经办人" align="center" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Credit_Control_CustomerName" label="客户名称" align="center" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Credit_Control_ApplicationTime" label="成立日期" align="center" show-overflow-tooltip width="120"></el-table-column>
                <el-table-column prop="RepaymentTime" label="到期日期" align="center" show-overflow-tooltip width="120"></el-table-column>
                <el-table-column prop="Credit_Control_ProjectMoney" label="项目金额" show-overflow-tooltip align="center" width="120"></el-table-column>
                <el-table-column prop="OverdueMoney" label="到期承诺金额" align="center" show-overflow-tooltip width="150"></el-table-column>
                <el-table-column prop="Credit_Control_ReturnMoney" label="已完成金额" show-overflow-tooltip align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_Control_UnfinishedMoney" label="未完成金额" show-overflow-tooltip align="center" width="120"></el-table-column>
                <el-table-column prop="CommitmentMoney" label="逾期未付额" align="center" show-overflow-tooltip width="120"></el-table-column>
                <el-table-column prop="AverageOverdueDays" label="平均逾期未付天数" show-overflow-tooltip align="center" width="180"></el-table-column>
                <el-table-column prop="Credit_Control_CommitmentAmount" label="30日内将到期承诺金额" show-overflow-tooltip align="center" width="180"></el-table-column>
                <el-table-column prop="Credit_Control_LitigationDay" label="诉讼时效剩余天数" show-overflow-tooltip align="center" width="180"></el-table-column>
                <el-table-column prop="IsProceeding" label="是否已提交诉讼" show-overflow-tooltip align="center" width="180">
                    <template v-slot="scope">
                        <div class="operation-bar" v-if="scope.row.IsProceeding && scope.row.IsProceeding != '--'">
                            <span class="operation-bar-block" @click="getModifiedstate(scope.row)">{{ scope.row.IsProceeding }}</span>
                        </div>
                        <div v-else>
                            {{ scope.row.IsProceeding }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="Credit_Control_FirstInstance" label="一审胜诉日期" show-overflow-tooltip align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_Control_ExecutionTime" label="二审胜诉日期" show-overflow-tooltip align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_Control_SecondInstance" label="向法院申请执行" show-overflow-tooltip align="center" width="150"></el-table-column>
                <el-table-column prop="OwnerEmail" label="查看" align="center" width="120" fixed="right">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="getOpenDetails(scope.row)">查看</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <el-dialog title="状态选择" :visible.sync="isStatusdialog" width="50%" :before-close="handleClose" :close-on-click-modal="false" center>
            <div v-for="(item, index) in StateListopt" :key="index" v-loading="isStatusLoading">
                <span class="multiple-title">{{ item.Name }}</span>
                <div>
                    <el-checkbox :isIndeterminate="item.isIndeterminate" v-model="item.checkAll" @change="handleCheckAllChange($event, item)">全选</el-checkbox>
                    <div style="margin: 15px 0"></div>
                    <el-checkbox-group v-model="item.checkFlag" @change="handleCheckedCitiesChange($event, item)">
                        <el-checkbox style="padding: 5px 0" v-for="city in item.StateList" :label="city.ID" :key="city.ID">{{ city.Name }}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleMultipleSave()">保存勾选状态</el-button>
            </span>
        </el-dialog>

        <el-dialog title="项目信息综合汇总" :visible.sync="isCollectdialog" width="700px" :before-close="handleisCollectClose" :close-on-click-modal="false">
            <div class="Collect">
                <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                    <el-descriptions-item label="项目金额">{{ collectMoneySUM.Credit_Control_ProjectMoney | thousandSeparator }}</el-descriptions-item>
                    <el-descriptions-item label="已完成金额">{{ collectMoneySUM.Credit_Control_ReturnMoney | thousandSeparator }}</el-descriptions-item>
                    <el-descriptions-item label="未完成金额">{{ collectMoneySUM.Credit_Control_UnfinishedMoney | thousandSeparator }}</el-descriptions-item>
                    <el-descriptions-item label="项目总完成率">{{ collectMoneySUM.ProjectMoneyRate }}</el-descriptions-item>
                    <el-descriptions-item label="按期付款额">{{ collectMoneySUM.Credit_Control_OnTimeReturnMoney | thousandSeparator }}</el-descriptions-item>
                    <el-descriptions-item label="按期完成率">{{ collectMoneySUM.OnTimeReturnMoneyRate }}</el-descriptions-item>
                    <el-descriptions-item label="逾期付款额">{{ collectMoneySUM.Credit_Control_OverdueReturnMoney | thousandSeparator }}</el-descriptions-item>
                    <el-descriptions-item label="逾期完成率">{{ collectMoneySUM.OverdueReturnMoneyRate }}</el-descriptions-item>
                    <el-descriptions-item label="项目逾期未付额">{{ collectMoneySUM.OverdueMoney | thousandSeparator }}</el-descriptions-item>
                    <el-descriptions-item label="平均逾期未付天数">{{ collectMoneySUM.AverageOverdueDays }}</el-descriptions-item>
                    <el-descriptions-item label="最长逾期付款额">{{ collectMoneySUM.MaxOverdueMoney | thousandSeparator }}</el-descriptions-item>
                    <el-descriptions-item label="最长逾期付款天数">{{ collectMoneySUM.MaxOverdueMoneyDay | thousandSeparator }}</el-descriptions-item>
                    <el-descriptions-item label="平均逾期付款天数">{{ collectMoneySUM.AvgDay }}</el-descriptions-item>
                    <el-descriptions-item label="诉讼失效剩余天数">{{ collectMoneySUM.Credit_Control_LitigationDay }}</el-descriptions-item>
                    <el-descriptions-item label="三十日内将到期承诺额">{{ collectMoneySUM.Credit_Control_CommitmentAmount | thousandSeparator }}</el-descriptions-item>
                    <el-descriptions-item label="项目到期承诺金额">{{ collectMoneySUM.CommitmentMoney | thousandSeparator }}</el-descriptions-item>
                </el-descriptions>
            </div>
        </el-dialog>
        <!-- <control-detail :isControlDetail="isControlDetail" :id="id" @handleisControlClose="handleisControlClose"></control-detail> -->
        <control-add :isControlAdd="isControlAdd" :controlprojectList="controlprojectList" @onClose="onClose"></control-add>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
// import controlDetail from './components/controlDetail.vue';
import controlAdd from './components/controlAdd.vue';
import { downloadFile, toLowerCaseKeys } from '@/utils/utils.js';
import { myMixin } from '@/utils/mixin.js';
import { cloneDeep } from 'lodash';
export default {
    name: 'creditControlproject',
    mixins: [myMixin],
    components: {
        Pagination,
        // controlDetail,
        controlAdd
    },
    data() {
        return {
            loadingBtn: false,
            isStatusdialog: false,
            isStatusLoading: false,
            isCollectdialog: false,
            isControlDetail: false,
            isControlAdd: false,
            id: 3,
            collectMoneySUM: {
                Credit_Control_ProjectMoney: '',
                Credit_Control_ReturnMoney: '',
                Credit_Control_UnfinishedMoney: '',
                ProjectMoneyRate: '',
                Credit_Control_OnTimeReturnMoney: '',
                OnTimeReturnMoneyRate: '',
                Credit_Control_OverdueReturnMoney: '',
                OverdueReturnMoneyRate: '',
                OverdueMoney: '',
                AverageOverdueDays: '',
                MaxOverdueMoney: '',
                MaxOverdueMoneyDay: '',
                AvgDay: '',
                Credit_Control_LitigationDay: '',
                Credit_Control_CommitmentAmount: '',
                CommitmentMoney: ''
            },
            params: {},
            dateTimer: [],
            tableData: [],
            StateListopt: [],
            ControlTypeopt: [],
            multiple_status_list: [],
            controlprojectList: []
        };
    },
    async mounted() {
        await this.getCreditTypeByRole();
        await this.getCreditStateList();
        await this.disposequeryID(this.$route.query);
        this.getCreditControls();
    },
    methods: {
        disposequeryID(params) {
            if (params.Credit_Control_Status) {
                switch (params.Credit_Control_Status) {
                    case '1':
                        this.params.mainselect = 5;
                        this.params.Credit_Control_Type = 2;
                        this.$forceUpdate();
                        break;
                    case '2':
                        this.params.mainselect = 5;
                        this.params.Credit_Control_Type = 1;
                        this.$forceUpdate();
                        break;
                    case '3':
                        this.params.mainselect = 1;
                        break;
                    case '4':
                        this.params.mainselect = 2;
                        this.selectCheckFlag(4);
                        break;
                    case '5':
                        this.params.mainselect = 3;
                        this.selectCheckFlag(5);
                        this.params.endLitigationDay = 90;
                        break;
                    case '6':
                        this.params.mainselect = 4;
                        this.selectCheckFlag(6);
                        break;
                }
            }
        },
        getModifiedstate(row) {
            this.$confirm('是否修改诉讼状态', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$newsApi.changeLawsuit({ ID: row.Credit_Control_ID }).then((res) => {
                        if (res.data.Resultcode == 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.Resultinfo
                            });
                            this.getCreditControls();
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.Resultinfo
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        /*
    重置
    */
        onRefresh() {
            this.dateTimer = [];
            this.StateListopt = [];
            this.multiple_status_list = [];
            this.params = {
                Credit_Control_Type: 0,
                StateList: '',
                officeman: '', // 经办人
                Enclosure: '', //原件存档
                startCredit_Control_ProjectMoney: '', //项目金额
                endCredit_Control_ProjectMoney: '',
                startReturnMoney: '', //已完成金额
                endReturnMoney: '',
                Orders_SN: '', //包含订单
                IsBranchOfficeID: '', //经办人所属单位
                startOnTimeReturnMoney: '', //按期付款额:
                endOnTimeReturnMoney: '',
                startOverdueReturnMoney: '', //逾期付款额
                endOverdueReturnMoney: '',
                startUnfinishedMoney: '', //未完成金额:
                endUnfinishedMoney: '',
                startCommitmentAmount: '', //三十日内将到期承诺金额
                endCommitmentAmount: '',
                startLitigationDay: '', //剩余天数
                endLitigationDay: '',
                Credit_Control_CustomerName: '', //客户名称
                CreditID: '',
                date_start: '',
                date_end: ''
            };
            this.getCreditStateList();
            this.getCreditControls(true);
        },
        /*
    查询列表
    */
        getCreditControls(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getCreditControls(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        filteropt() {
            let params = cloneDeep(this.params);
            if (this.dateTimer && this.dateTimer.length > 0) {
                params.date_start = this.dateTimer[0];
                params.date_end = this.dateTimer[1];
            }
            params.IsBranchOfficeID = this.params.IsBranchOfficeID ? 1 : 0;
            return { json: JSON.stringify(toLowerCaseKeys(params)), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },

        getCreditControlExport() {
            this.$newsApi.getCreditControlExport(this.filteropt()).then((res) => {
                if (res.data.Resultcode == 0) {
                    downloadFile(res.data.data, res.data.Resultinfo);
                }
            });
        },
        getChangeControlstatus() {
            this.isStatusdialog = true;
        },
        getCreditTypeByRole() {
            return this.$newsApi.getCreditTypeByRole({ credit_action: 'Read' }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.ControlTypeopt = res.data.data;
                }
            });
        },
        getChangeControlType() {
            this.params.StateList = '';
            this.StateListopt = [];
            this.getCreditStateList();
        },
        getCreditStateList() {
            this.isStatusLoading = true;
            return this.$newsApi
                .getCreditStateList({ type: this.params.Credit_Control_Type })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.StateListopt = res.data.data;
                        this.StateListopt.forEach((item) => {
                            this.$set(item, 'isIndeterminate', true);
                            this.$set(item, 'checkAll', false);
                            this.$set(item, 'checkFlag', []);
                        });
                        console.log(this.StateListopt, ' this.StateListopt');
                    }
                })
                .finally(() => (this.isStatusLoading = false));
        },

        getCreditControlStatistics() {
            this.isCollectdialog = true;
            this.$newsApi.getCreditControlStatistics(this.filteropt()).then((res) => {
                if (res.data.Resultcode == 0) {
                    if (res.data.data && res.data.data.length > 0) {
                        this.collectMoneySUM = res.data.data[0];
                    }
                }
            });
        },
        handleCheckAllChange(val, row) {
            if (val) {
                row.checkFlag = row.StateList.map((item) => {
                    return item.ID;
                });
                return;
            }
            row.checkFlag = [];
        },
        handleCheckedCitiesChange(val, row) {
            let checkedCount = val.length;
            console.log(val, row, checkedCount);
            row.checkAll = row.StateList.length === row.checkFlag.length;
            row.isIndeterminate = checkedCount > 0 && checkedCount < row.checkFlag.length;
        },

        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getCreditControls();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getCreditControls();
        },
        getopenControlAdd() {
            this.$newsApi.getCreditAddCheck().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.isControlAdd = true;
                    this.controlprojectList = res.data.data;
                    console.log(res.data.data);
                    sessionStorage.setItem('controlprojectList', JSON.stringify(res.data.data));
                    // this.$router.push('/creditControlproject/controlprojectAdd') // 替换当前路由
                }
            });
        },
        onClose(flag) {
            if (flag) {
                this.onRefresh();
            }
            this.isControlAdd = false;
        },
        handleMultipleSave() {
            const result = [];
            this.StateListopt.forEach((item) => {
                Array.prototype.push.apply(
                    result,
                    item.StateList.filter((idm) => item.checkFlag.includes(idm.ID))
                );
            });
            this.params.StateList = result.map((item) => item.ID).join(',');
            this.multiple_status_list = result;
            //   this.params.StateList = this.StateListopt.flatMap(item => item.checkFlag).join(',')
            this.isStatusdialog = false;
        },
        handleClose() {
            console.log(this.StateListopt);
            this.isStatusdialog = false;
        },
        handleisCollectClose() {
            this.isCollectdialog = false;
        },
        /*
    详情页面
    */
        getOpenDetails(row) {
            console.log(row);
            this.id = row.Credit_Control_ID;
            this.isControlDetail = true;
            this.$router.push({ path: '/creditControlproject/details', query: { id: this.id } });
        },
        handleisControlClose() {
            this.onRefresh();
            this.isControlDetail = false;
        },
        selectCheckFlag(e) {
            this.StateListopt.forEach((item) => {
                if (item.Name == '催款函、对账函、律师函状态' && e == 4) {
                    item.checkFlag = [8];
                    this.params.StateList = '8';
                }
                if (item.Name == '催款函、对账函、律师函状态' && e == 5) {
                    item.checkFlag = [1, 2, 5, 6, 7, 8, 9];
                    this.params.StateList = '1,2,5,6,7,8,9';
                }
                if (item.Name == '口头还款计划、书面还款计划、书面欠款确认状态、民事调解还款计划、动态码审批还款计划、以票取款还款计划状态' && e == 5) {
                    item.checkFlag = [1, 2];
                    this.params.StateList = '1,2';
                }
                if (item.Name == '诉讼状态' && e == 6) {
                    item.checkFlag = [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];
                    this.params.StateList = '12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28';
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/.Collect .el-descriptions-item__cell {
    text-align: center !important;
}

/deep/.Collect.custom-label {
    text-align: center !important;
    width: 170px;
}

.multiple-title {
    font-size: 15px;
    font-weight: 522;
    color: #222222;
    line-height: 50px;
}

.multiple-status-checked {
    font-size: 13px;
}

.multiple-status-checked-value {
    color: #000000;
    margin-right: 10px;
}
</style>
